const TYPES = {
  CREATE_EVENT_TYPE: 'CREATE_EVENT_TYPE',
  UPDATE_EVENT_TYPE: 'UPDATE_EVENT_TYPE',
  DELETE_EVENT_TYPE: 'DELETE_EVENT_TYPE',
  GET_EVENT_TYPES_VISIBILITY: 'GET_EVENT_TYPES_VISIBILITY',
  UPDATE_EVENT_TYPES_VISIBILITY: 'UPDATE_EVENT_TYPES_VISIBILITY'
};

export default TYPES;
